import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import initialState from "./initial";
import { updateObjectState } from "../utils";

const useGeneralStore = create(
  persist(
    immer((set, get) => ({
      ...initialState, // Spread the initial state
      changeLanguage: (language) => set({ language: language }),
      toggleLanguageSelector: (isShow) => set({ languageSelector: { isShow: isShow } }),
      resetGeneral: () => set(initialState), // Reset function
    })),
    {
      name: "pearl-general", //name of store, must be unique
      //storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used
    }
  )
);

export default useGeneralStore;
